import './maintenance.scss';

import { useTranslation } from "react-i18next";
import { SelectLanguage } from '../select-language/select-language';

export function Maintenance(){
    const { t } = useTranslation();
    
    return(
        <>
            <div className='maintenance-container flex flex-column'>
            <div className='lang-container'>
                <SelectLanguage/>
            </div>
                <section className='section-container padding-0-15'>
                    <img src='/logo.svg' alt='Les toiles de La Juine' title='Les toiles de La Juine' width='auto'/>
                    <h1>{t("maintenance.label")}</h1>
                    <p className='maintenance-message'>{t("maintenance.message")}</p>
                    
                </section>
            </div>
        </>
    )
}